import React from "react";
import { SecretLiveness } from "@sscs/report/ui";
import {
  Card,
  DataTable,
  DataTableColumn,
  LoadingDots,
  NLinesShowMore,
  Table,
} from "@sscs/ui";
import { InsightDetails, SecretInsight } from "../../../types";
import styles from "./details.module.scss";
import PolicyViolations from "./PolicyViolations/PolicyViolations";

type SecretProps = {
  issue: SecretInsight;
  issueDetails: InsightDetails | undefined;
};

const ENDPOINT_COLUMNS: DataTableColumn[] = [
  { id: "liveness", label: "Liveness", width: "100px" },
  { id: "label", label: "Label", width: "20%" },
  { id: "location", label: "Location", width: "40%" },
  { id: "secret", label: "Secret", width: "40%" },
];

const EndpointsTable = ({
  issueDetails,
}: SecretProps): React.JSX.Element | null => {
  if (!issueDetails) {
    return <LoadingDots />;
  }

  if (issueDetails.issue_type !== "secret") {
    return null;
  }

  return (
    <DataTable title="Exposed secrets" columns={ENDPOINT_COLUMNS}>
      {issueDetails.endpoints.map((item, index) => (
        <Table.Row hover key={index}>
          <Table.Cell>
            <SecretLiveness liveness={item.liveness} exposed={true} />
          </Table.Cell>
          <Table.Cell>{item.label}</Table.Cell>
          <Table.Cell>{item.location}</Table.Cell>
          <Table.Cell>
            <NLinesShowMore value={item.secret} numberOfLines={3} />
          </Table.Cell>
        </Table.Row>
      ))}
    </DataTable>
  );
};

const Secret = ({ issue, issueDetails }: SecretProps): React.JSX.Element => {
  return (
    <>
      <div className={styles["description-and-issues-container"]}>
        <Card.Card>
          <Card.Title>Service description</Card.Title>
          <Card.Content>
            <div>{issue.long_description}</div>
          </Card.Content>
        </Card.Card>
        <PolicyViolations
          violations={issue.caused_violations}
          evaluations={issue.risk_assessment_evaluation}
        />
      </div>
      <EndpointsTable issue={issue} issueDetails={issueDetails} />
    </>
  );
};

export default Secret;
